import React, { useState, useEffect } from "react";
import Loadable from "react-loadable";
import homeCar from "../../Assets/newAsset/lpassets/homeCar.svg";
import logoWhite from "../../Assets/newAsset/lpassets/clearFooter.svg";
import { FiPhone, FiMail } from "react-icons/fi";
import { useLocation, useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../components/Loader/Loader";
import EmailImg from "../../Assets/newAsset/lpassets/newEmail.png";
import Content from "../homePage/Components/Content";
import LpForm from "./LpForm";
import "./comboOffer.css";
// import FaqAccorComponent from "../homePage/FaqAccorComponent";
// import ScrolltoTop from "../../components/Scrolltotop/ScrolltoTop";
// import Featured from "../homePage/Components/Featured";
// import Apointment from "../homePage/Components/Apointment";
//IMPORTING ACTIONS FOR REEDUX API CALL
import { getCity, getCall, getPackageDetails } from "../../Redux/Actions";
import LpActions from "../LandingPages/LpActions";
import { connect } from "react-redux";
import { Modal } from "react-responsive-modal";
import Popup from "../../components/PopupNotification/LpPopup";

const scrollTop = () => {
  window.scroll({
    top: 340,
    left: 0,
    behavior: "smooth",
  });
};

const stepsData = [
  {
    id: 1,
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/245666fd-7e57-4dae-90bb-a8381ac0da59.webp",
    desc: "Temperature Checks",
  },
  {
    id: 2,
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/5aa857e6-ec25-48f9-a86d-7de73342fa20.webp",
    desc: "Secure Packaging",
  },
  {
    id: 3,
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/ac00e3ea-c6c1-4432-8a67-1260075a892f.webp",
    desc: "Stored Safely",
  },
  {
    id: 4,
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/84cad4f1-ba4e-40ec-8380-10e1e2223ba8.webp",
    desc: "Regular Sanitization",
  },
  {
    id: 5,
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/0b9d508f-c135-4ccb-a61c-d73cd7f25c0a.webp",
    desc: "No Contact Delivery",
  },
];
//FAQ's Data//

const FAQ = [
  {
    question: "What is included in a full body checkup?",
    answer:
      "A full-body health checkup consists of various tests including Thyroid Profile Test, Complete Hemogram Test, Kidney Function Test, Lipid Profile Test, Liver Function Test, Urine Routine Test, Blood Glucose Test, and others. ",
  },
  {
    question: "Which complete body checkup is best?",
    answer: {
      faq:
        "Redcliffe's complete body health check is a comprehensive health checkup package that helps in the diagnosis of all the organs and bodily functioning systems. Some of the popular full body packages that help in the complete assessment of organs are:",
      list: [
        "LFT - Liver Function Tests with GGT",
        "KFT - Kidney Function Tests",
        "CBC - Complete Hemogram",
        "Electrolytes Profile",
        "Calcium, Phosphorus & ALP",
        "ESR, Uric Acid and Protein, and others",
      ],
    },
  },
  {
    question: "How much is the full body checkup price?",
    answer: {
      faq:
        "Redcliffe Labs offers health checkup packages starting from as low as Rs. 699. Depending upon your medical needs and health requirements, you can pick from our health checkup packages like:",
      list: [
        "Redcliffe Advance Full Body Checkup – Male",
        "Redcliffe Advance Full Body Checkup – Female",
        "Redcliffe Advance Full Body Checkup",
        "Redcliffe Advance Plus Full Body Checkup",
        "Redcliffe Smart Plus Full Body Checkup",
      ],
    },
  },
  {
    question: "How many tests are covered in a full body checkup?",
    answer: {
      faq:
        "Redcliffe offers Full body checkups starting at only Rs. 699. A whole-body checkup includes a combination of general and additional tests such as:",
      list: [
        "General tests:",
        "Urine Routine Analysis",
        "Stool Test (Optional)",
        "Additional tests",
        "Thyroid Stimulating Hormone (TSH)",
        "HbsAg",
        "Serum Phosphorus",
        "PSA (for Men) and others",
      ],
    },
  },
  {
    question: "How long does a full-body checkup take?",
    answer:
      "The blood sample collection timing for a full body check-up takes a few minutes. The sample is then sent to the laboratories for analysis and examination.",
  },
  {
    question: "Why Choose Full Body Checkup from Redcliffe Labs?",
    answer:
      "Redcliffe Labs is a diagnostic lab that offers an expansive range of Full Body Checkup Health Packages according to patients’ needs and medical conditions. We are best known for our advanced technology and state-of-the-art infrastructure with affordable health checkup packages.Redcliffe Labs is well equipped with all the advanced medical tools and accessories. We make sure that every test performed at our centre should fetch the most reliable and best results possible. Our diagnostic care meets all the global healthcare standards offering a secure environment to the patients. Also, the full-body checkup cost at Redcliffe Labs is affordable.",
  },
  {
    question: "How often should I do a body check-up?",
    answer:
      "How often one should get a body checkup done, depends on the family history of patients, their age, and sex and lifestyle habits. Going by the advice of the medical experts at Redcliffe Labs, routine health checkups should be done at least once a year for patients over the age of 50 or above and once every 2-3 years for people younger than 50. The requirement or the need for the tests may vary depending upon certain medical conditions and chronic diseases, regardless of age.",
  },
  {
    question: "Do healthy people also require full-body checkups frequently?",
    answer:
      "Medical experts at Redcliffe recommend undergoing full-body checkups yearly for every individual no matter if the person is healthy or not. But there are professionals who suggest going for a selective approach for averting any disease. It means healthy people don’t have to undergo full-body check ups yearly. So, it entirely depends from person to person, doctor to doctor. We recommend visiting the full-body checkup centres once a year at least to ensure improved health.",
  },
  {
    question: "Is full body check-up good?",
    answer:
      "Regular Full Body Checkup is important for our health for a variety of reasons. The sudden inexplicable health concerns call for the immediate medical intervention of an expert. Regular complete body checkup is important to keep your health in top order by timely assessing your general health with regular health checks for early detection of certain diseases and illnesses.Health checks on time-to-time benefits in promoting better and improved health. Doctors at our centre also educate the patients to lead a healthy life and how they can include healthy habits in their routine.",
  },
  {
    question: "What is included in a whole body checkup?",
    answer: {
      faq: "The tests list of Full Body Checkup includes:",
      list: [
        "Liver Function Test",
        "Thyroid Profile: TSH, T3, T4",
        "Kidney Function Test: Uric Acid, Serum Creatinine, Blood Urea",
        "Hb1AC",
        "Blood and Urine tests",
        "Hepatitis B test",
      ],
    },
  },
];

//NEW CARDS DATA

import "./Newlp.css";

// import ErrorPage from "../ErrorPage";

function Newlp(props) {
  // const history = useHistory();

  //calling city name api

  const Featured = Loadable({
    loader: () => import("../homePage/Components/Featured"),
    loading: Loader,
  });

  const Apointment = Loadable({
    loader: () => import("../homePage/Components/Apointment"),
    loading: Loader,
  });

  // const Content = Loadable({
  //   loader: () => import('../homePage/Components/Content'),
  //   loading: Loader,
  // });

  const ScrolltoTop = Loadable({
    loader: () => import("../../components/Scrolltotop/ScrolltoTop"),
    loading: Loader,
  });

  // const LpForm = Loadable({
  //   loader: () => import('./LpForm'),
  //   loading: Loader,
  // });

  const FaqAccorComponent = Loadable({
    loader: () => import("../homePage/FaqAccorComponent"),
    loading: Loader,
  });

  const ErrorPage = Loadable({
    loader: () => import("../ErrorPage"),
    loading: Loader,
  });

  useEffect(() => {
    dispatch(getCity());
  }, []);

  const dispatch = useDispatch();
  //GETTING DATA FROM STORE (CITIES NAME) STARTS HERE

  //form page details
  const [userName, setUserName] = useState("");
  const [userNumber, setUserNumber] = useState("");
  const [nameError, setNameEror] = useState("");
  const [phoneError, setPhoneEror] = useState("");
  // const [footerTel, setTelNum] = useState("");
  const [disable, setDisable] = useState(true);
  const [open1, setOpen1] = useState(false);
  const onOpenModal1 = () => setOpen1(true);
  const onCloseModal1 = () => setOpen1(false);

  //validation on submit button
  useEffect(() => {
    if (userName == "" || userNumber == "") {
      setDisable(true);
      console.log("inside if");
    } else {
      setDisable(false);
      console.log("inside else");
    }
  }, [userName, userNumber]);

  const location = useLocation();
  const params = useParams();

  //GETTING PACKAGE DETAILS FROM STORE
  // const packageDetails = useSelector((state) => state.packageDetails);
  // const { loading, packDetail, error } = packageDetails;

  var url = `https://redcliffelabs.com${location.pathname}/bottom${location.search}`;

  const pacakgeNameFromUrl = params.slug;

  const [successBtn, setSuccessBtn] = useState(false);

  //CALLING PACAKGE DETAILS  API
  useEffect(() => {
    props.getLppackageDetails("smart-full-body-checkup");
  }, [pacakgeNameFromUrl]);

  let packDetail = props?.package;
  // useEffect(() => {
  //   if (location.pathname.includes("/lp/fb/")) {
  //     setTelNum("898 898 9393");
  //   } else if (location.pathname.includes("/lp/sms/")) {
  //     setTelNum("931 126 1990");
  //   } else if (location.pathname.includes("/lp/")) {
  //     setTelNum("898 898 8585");
  //   }
  // }, []);

  const callRecieve = useSelector((state) => state.callRecieve);
  const { success } = callRecieve;

  const handelUserName = (e) => {
    setUserName(e.target.value);
    const characterRegex = /^([A-Za-z]+[ ]?)+$/;
    setNameEror("");
    if (!e.target.value.match(characterRegex)) {
      setNameEror("invalid user name");
    }
    if (e.target.value == "") {
      setNameEror("");
    }
  };
  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 2
  const validatePhoneNumber = () => {
    let phoneno = /^\d{10}$/;
    if (!userNumber.match(phoneno) || parseInt(userNumber[0]) < 6) {
      setPhoneEror("Enter a valid number*");
      return false;
    } else {
      return true;
    }
  };
  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 1
  const handelPhoneChange = (e) => {
    setUserNumber(e.target.value);
    setPhoneEror("");
  };

  const handelSubmit = (e) => {
    e.preventDefault();
    const checkVal = validatePhoneNumber();

    if (checkVal) {
      const body = {
        name: userName,
        phone_no: userNumber,
        source: "Ecommerce",
        city: "",
        url,
      };

      setUserNumber("");
      setUserName("");
      setSuccessBtn(true);
      setTimeout(() => {
        setSuccessBtn(false);
      }, 2000);
      setPhoneEror("");
      dispatch(getCall(body));
    }
  };

  useEffect(() => {
    setTimeout(() => {
      onOpenModal1();
    }, 60000);
  }, []);

  return props?.loading ? (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <Loader />
    </div>
  ) : props?.package.length == 0 ? (
    <div className="errorDIVNo">
      <ErrorPage />
      <div className="footerLp">
        <div className="footerContainer">
          <div className="footerFirstRow">
            <div className="logoIMg">
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/6666d24d-f9ef-44e3-8aa7-5230252a55c7.webp"
                alt={logoWhite}
              ></img>
            </div>
            <div className="footerDesc">
              <p>
                Redcliffe Labs is an accredited advanced diagnostic laboratory
                that aims at providing top-notch consistent and accurate
                laboratory services with modern technology and equipment all
                inclusive of logistics management.
              </p>
            </div>
          </div>
          <div className="footerSecondRow">
            <div className="footerLogo">
              <span>Contact Us</span>
              <div className="emailLogo">
                <span>
                  <FiMail />
                </span>
                care@redcliffelabs.com
              </div>
              <a href={`tel:08069205242`}>
                <div className="phoneLogo">
                  <span>
                    <FiPhone />
                  </span>
                  08069205242
                </div>
              </a>
            </div>
          </div>
          <div className="borderDiv"></div>
          <div className="footerThirdRow">
            <div className="footerMsg">
              <p>
                Disclaimer: As per "Pre-Natal Diagnostic Techniques (Regulation
                and prevention of Misuse) Act, 1994", our labs strictly does not
                determine the sex of the fetus.
              </p>
              <p>
                Redcliffe Labs <br /> © 2022. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="NewlpBackground">
      <div className="newMobileBackground MobileBgCombo">
        <div className="redLogos_milinTest">
          <div className="leftSide_lp">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/69780ca3-4abe-4f88-a130-7a1f182ec0bd.webp"
              alt="transparentLOGO}"
            />
          </div>
          <div className="rightSide_lp">
            <div className="top__bar">
              <p>No.1 Diagnostics Lab for me & my family!</p>
            </div>
            <div className="bottom__bar">
              <span>~Gautam Gambhir</span>
            </div>
          </div>
        </div>
        <div className="milindImages_new">
          <img
            src="https://redcliffelabs.com/static/media/Gambhi.b6915a86.webp"
            alt="profile-img"
            className="" style={{borderBottom:'solid 7px #e5184e', borderRadius:'10px'}}
          />
         
          {packDetail && packDetail.name ? (
            <p className="mainTagHeadingMobile comboOfferName">
              Smart Full Body Checkup / Combo for 2
            </p>
          ) : null}
        </div>
      </div>
      <div className="lpContainerNew">
        <div className="brandLogo">
          <img
            src={
              "https://staticcdn.redcliffelabs.com/media/gallary-file/None/69780ca3-4abe-4f88-a130-7a1f182ec0bd.webp"
            }
            alt={
              "https://staticcdn.redcliffelabs.com/media/gallary-file/None/69780ca3-4abe-4f88-a130-7a1f182ec0bd.webp"
            }
          ></img>
        </div>
        {packDetail && packDetail.name ? (
          <p className="lpmainTagHeading mobileDisplayComboOffer">
            Smart Full Body Checkup <br /> / Combo for 2
          </p>
        ) : null}

        <div className="lpformDivchildren">
          <div className="lpForm">
            <div className="Report__Params">
              <div className="Report__Test bg__blue">
                <span>
                  {packDetail && packDetail.parameter
                    ? packDetail.parameter
                    : null}
                </span>
                {packDetail && packDetail.parameter > 1 ? "Tests" : "Test"}
              </div>
              <div className="Report__rightSide">
                <div className="Report__Mrp oldPrice">
                  <span>MRP</span>
                  <span style={{ textDecoration: "line-through" }}>
                    {" "}
                    &#8377; 2998
                  </span>
                </div>

                <div className="Report__offerPrice">
                  <span>Offer Price</span>
                  &#8377; 1199
                </div>
              </div>
            </div>
            <div className="comboLpForm smssfbcp">
              <LpForm
                isLp={true}
                butname={"SUBMIT"}
                buttonId={"LpTop"}
                formId={"LpForm"}
                lpNumber={"0806 920 5242"}
                position={"Top"}
              />
            </div>
          </div>
          {/* <div className="startDiv">
            <div className="top__bar">
              <p>No.1 Diagnostics Lab for me & my family!</p>
            </div>
            <div className="bottom__bar">
              <p>Supermodel & Fitness Guru</p>
              <span>~Milind Soman</span>
            </div>
          </div> */}
        </div>
        <div className="lpFormDiv testParamNewDivMoveDown comboOfferLpForm">
          <div className="NewlpParameters">
            <h5>Test Parameters</h5>

            <p className="parameterFont">
              Now with{" "}
              {packDetail && packDetail.parameter ? packDetail.parameter : null}{" "}
              {packDetail?.parameter == 1
                ? "test only"
                : "tests which includes "}
            </p>

            <p className="paraDesc">
              {packDetail && packDetail.description
                ? packDetail.description
                : null}
            </p>
          </div>
        </div>

        {/* <div className="newCardslp"> */}
        {/* <div className="NewlpDivRow">
            {packDetail.tat_time ? (
              <div className="lpcards">
                <div className="card__imglp">
                  <img
                    src={
                      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/ac337b36-2d09-4dff-81e9-4de9ad5e805e.webp"
                    }
                    alt={
                      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/ac337b36-2d09-4dff-81e9-4de9ad5e805e.webp"
                    }
                  />
                </div>
                <div className="card__contentlp">
                  <span className="mainHeading">Get Reports in</span>
                  <span className="redHeading">{packDetail.tat_time}</span>
                </div>
              </div>
            ) : null}
            {packDetail && packDetail.fasting_time ? (
              <div className="lpcards">
                <div className="card__imglp">
                  <img
                    src={
                      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/9744cfba-3b7d-478e-b33d-cb4a82a2404b.webp"
                    }
                    alt={
                      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/9744cfba-3b7d-478e-b33d-cb4a82a2404b.webp"
                    }
                  />
                </div>
                <div className="card__contentlp">
                  <span className="mainHeading"> Fasting Requirement</span>
                  <span className="redHeading">{packDetail.fasting_time}</span>
                </div>
              </div>
            ) : null}
      
            {packDetail && packDetail.sample ? (
              <div className="lpcards">
                <div className="card__imglp">
                  <img
                    src={
                      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/3f2cc36c-46ba-4f3b-a0be-9e2a4691f317.webp"
                    }
                    alt={
                      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/3f2cc36c-46ba-4f3b-a0be-9e2a4691f317.webp"
                    }
                  />
                </div>
                <div className="card__contentlp">
                  <span className="mainHeading">Sample Collection</span>
                  <span className="redHeading">{packDetail.sample}</span>
                </div>
              </div>
            ) : null}

          
            {packDetail && packDetail.home_collection ? (
              <div className="lpcards">
                <div className="card__imglp">
                  <img src={homeCar} />
                </div>
                <div className="card__contentlp">
                  <span className="mainHeading">Home Collection</span>
                  <span className="redHeading">Available</span>
                </div>
              </div>
            ) : null}

            {packDetail && packDetail.recommended_age ? (
              <div className="lpcards">
                <div className="card__imglp">
                  <img
                    src={
                      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/94275e49-7aaf-4718-ae5c-02564223b533.webp"
                    }
                    alt={
                      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/94275e49-7aaf-4718-ae5c-02564223b533.webp"
                    }
                  />
                </div>
                <div className="card__contentlp">
                  <span className="mainHeading">Age Group</span>
                  <span className="redHeading">
                    {packDetail.recommended_age} years
                  </span>
                </div>
              </div>
            ) : null}
          </div> */}
        {/* </div> */}
      </div>
      <div className="newDivOffer comboOfferDiv">
        <div className="topSideDiv">
          <div className="leftSide_offer">
            <p>
              1 + 1 Offer <span className="span_blue bold"> with </span>
              <span className="span_blue">Redcliffe Labs</span>
            </p>
          </div>
          <div className="right_sideOfer">
            <div className="innerBorder">
              <p className="pintext_offr">Smart Full Body Checkup For Two</p>
              <p className="pintext_offr">
                @ Rs 1199 <span className="span_blue"> BOOK 80+ Tests</span>
              </p>
              <p className="span_blue">
                Which Include Liver, Kidney, Thyroid, Lipid, CBC, Urine(R/M) &
                Sugar
              </p>
            </div>
          </div>
        </div>
        <div className="BottomDiv">
          <p className="span_blue">CALL NOW</p>
          <a href={`tel:08069205242`}>
            <button> 08069205242 </button>
          </a>
        </div>
      </div>
      {/*** wHY CHOOSE US */}

      <div className="WhyChooseUs">
        <div className="whyUscontainer">
          <h3>Why Choose Us?</h3>
          <div className="Four_div_box">
            <div className="For_Image_And_text">
              <div className="WhyChooseUslogo">
                <img
                  src={
                    "https://staticcdn.redcliffelabs.com/media/gallary-images/None/ae34b20a-80ce-4813-b2e8-e1afb4731f53.webp"
                  }
                  alt="Assured Safety"
                />
              </div>
              <p className="whyChooseUspara"> Assured Safety</p>
            </div>
            <div className="For_Image_And_text">
              <div className="WhyChooseUslogo">
                <img
                  src={
                    "https://staticcdn.redcliffelabs.com/media/gallary-images/None/6e9c830a-513d-4477-a405-61abc9e94187.webp"
                  }
                  alt="Certified Labs"
                />
              </div>
              <p className="whyChooseUspara"> Certified Labs</p>
            </div>
            <div className="For_Image_And_text">
              <div className="WhyChooseUslogo">
                <img
                  src={
                    "https://staticcdn.redcliffelabs.com/media/gallary-images/None/d790df8a-dc9c-4355-bd73-4b4d81821382.webp"
                  }
                  alt="Free Sample Pick-Up"
                />
              </div>
              <p className="whyChooseUspara">Free Sample Pick-Up</p>
            </div>
            <div className="For_Image_And_text">
              <div className="WhyChooseUslogo">
                <img
                  src={
                    "https://staticcdn.redcliffelabs.com/media/gallary-images/None/02f40e8a-d0ff-41de-bdea-4f69968c0ae0.webp"
                  }
                  alt="Accurate Reports"
                />
              </div>
              <p className="whyChooseUspara"> Accurate Reports</p>
            </div>
          </div>
          <div className="forBackgroundcolor">{/* Blank */}</div>
        </div>
      </div>
      {/**SAFETY STEPS */}
      <div className="safetyDiv">
        <h3>5 Steps to Safety</h3>
        <p>
          {" "}
          <span>10+ Lacs</span> Total orders delivered
        </p>
        <div className="safetySteps">
          {stepsData.map((values, index) => (
            <div className="safety__card" key={values.id}>
              <div className="safety_cardIMG">
                <img src={values.img} alt="image"></img>
              </div>
              <div className="steps">
                <span>{values.id}</span>
              </div>
              <div className="safetyStep">
                <span>{values.desc}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/***APPOINTMENT DIV */}
      {/* <div className="appointMentLpDiv">
        <Apointment
          img={
            "https://staticcdn.redcliffelabs.com/media/gallary-images/None/76164f75-aed7-4ac1-a401-c23961ee59e7.webp"
          }
          parentPath={"lpPage"}
        />

        <div className="mobileApointment">
          <h5>Make Appointment</h5>
          <p>Start Your Journey With Healthy India Ki Trusted Lab.</p>
        </div>
        <LpForm
          butname={"Book Your Test"}
          position={"bottom"}
          title={"Book Your Test"}
          isLp={true}
          lpNumber={"0806 920 5242"}
        />
      </div> */}

      <Featured />
      {/*** TESTIMONIAL */}
      <Content title="Testimonials" Ispackage={false} isTestimonial={true} />
      {/**FAQS */}
      <div className="FAQforLp ">
        <h1 className="h1style"> Frequently Asked Questions</h1>
        {FAQ?.length > 0 &&
          FAQ?.map((value, index) => (
            <div key={value.id}>
              <FaqAccorComponent value={value} />
            </div>
          ))}
      </div>
      {/***FOOTER */}
      {/**BASIC FOOTER */}
      <div className="footerLp">
        <div className="footerContainer">
          <div className="footerFirstRow">
            <div className="logoIMg">
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/6666d24d-f9ef-44e3-8aa7-5230252a55c7.webp"
                alt={logoWhite}
              ></img>
            </div>
            <div className="footerDesc">
              <p>
                Redcliffe Labs is an accredited advanced diagnostic laboratory
                that aims at providing top-notch consistent and accurate
                laboratory services with modern technology and equipment all
                inclusive of logistics management.
              </p>
            </div>
          </div>
          <div className="footerSecondRow">
            <div className="footerLogo">
              <span>Contact Us</span>
              <div className="emailLogo">
                <span>
                  <FiMail />
                </span>
                care@redcliffelabs.com
              </div>
              <a href={`tel:08069205242`}>
                <div className="phoneLogo">
                  <span>
                    <FiPhone />
                  </span>
                  08069205242
                </div>
              </a>
            </div>
          </div>
          <div className="borderDiv"></div>
          <div className="footerThirdRow">
            <div className="footerMsg">
              <p>
                Redcliffe Labs <br /> © 2022. All rights reserved.
              </p>
              <p>
                Disclaimer: As per "Pre-Natal Diagnostic Techniques (Regulation
                and prevention of Misuse) Act, 1994", our labs strictly does not
                determine the sex of the fetus.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/***FIXED FOOTER */}
      <div className="Lpfooter">
        <div className="lpfooter__content">
          <form onSubmit={handelSubmit}>
            <div className="nameInput ">
              Name
              <input
                type="text"
                onChange={handelUserName}
                className={nameError ? "colorRed" : ""}
                placeholder={nameError ? nameError : "Enter Name"}
                value={nameError ? () => setUserName("") : userName}
              ></input>
            </div>
            <div className="phoneInput">
              Phone Number
              <input
                type="text"
                className={phoneError ? "colorRed" : ""}
                placeholder={phoneError ? phoneError : "Enter Phone Number"}
                value={phoneError ? () => setUserName("") : userNumber}
                onChange={handelPhoneChange}
                required
              ></input>
            </div>

            {successBtn ? (
              <div className="submitButton__lpfooter">
                <button
                  disabled="disabled"
                  className="btnSuccess"
                  type="submit"
                >
                  Success
                </button>
              </div>
            ) : (
              <div className="submitButton__lpfooter">
                <button
                  id="Lpbottom"
                  disabled={nameError || disable ? "disabled" : null}
                  className={nameError || disable ? "disabled" : null}
                  type="submit"
                >
                  Book Now
                </button>
              </div>
            )}
          </form>
        </div>
        <button id="MobFotterButton" onClick={scrollTop}>
          Book Now
        </button>
      </div>

      {/* Notification popup */}
      <Modal
        classNames={{
          overlay: "customOverlay",
          modal: "notificationPopup_modal",
        }}
        open={open1}
        onClose={onCloseModal1}
        center
      >
        <Popup setOpen={setOpen1} />
      </Modal>

      <ScrolltoTop />
    </div>
  );
}

// export default Newlp
const mapStateToProps = (state) => ({
  package: state?.lpPackage?.lpPackageData,
  loading: state?.lpPackage?.loadinglp,
  success: state?.lpPackage?.success,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getLppackageDetails: (lpslug) => {
      dispatch(LpActions.getLppackageDetails(lpslug));
    },
    getCall: (body) => {
      dispatch(LpActions.getCall(body));
    },
  };
};

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(React.memo(Newlp)),
};
